import React from 'react';
import { Link } from 'react-router-dom';

export const WorkOrderFindingsSummary = ({ findings = [], followUps = [], machineryId, testId }) => {
  if (!findings.length) return null;
  return <section className="space-y-3 text-sm min-w-0" data-testid={testId}>
    <h3 className="font-semibold">Service findings</h3>
    {findings.map((f) => {
      const current = followUps.find((fu) => fu.id === f.follow_up_id);
      const outstanding = f.disposition === 'follow_up' && current?.status === 'open';
      return <div key={f.id} className={`border-l-2 pl-3 space-y-1 ${outstanding ? 'border-amber-400' : 'border-slate-200'}`} data-testid={`${testId}-${f.id}`}>
        <p className={`text-xs font-medium ${outstanding ? 'text-amber-800' : 'text-slate-600'}`} data-testid={`${testId}-status-${f.id}`}>
          {f.disposition === 'addressed' ? 'Addressed during service' : f.disposition === 'recorded' ? 'Recorded only' : current?.status === 'resolved' ? 'Follow-up closed' : current?.status === 'open' ? 'Follow-up required' : 'Follow-up recorded'}
        </p>
        <p className="whitespace-pre-wrap break-words" data-testid={`${testId}-description-${f.id}`}>{f.description}</p>
        {f.action_notes && <p className="whitespace-pre-wrap break-words text-slate-600" data-testid={`${testId}-notes-${f.id}`}>{f.action_notes}</p>}
        {f.recorded_at && <p className="text-xs text-slate-500" data-testid={`${testId}-recorded-${f.id}`}>
          Recorded {new Date(f.recorded_at).toLocaleDateString()}{f.recorded_by_name ? ` · ${f.recorded_by_name}` : ''}
        </p>}
        {f.linked_work_order_id && machineryId && <Link className="text-xs underline text-blue-700" data-testid={`${testId}-wo-link-${f.id}`}
          to={`/machinery/${machineryId}?workOrder=${f.linked_work_order_id}`}>Follow-up work order {f.linked_work_order_number ? `#${f.linked_work_order_number}` : ''} →</Link>}
      </div>;
    })}
  </section>;
};